import React from 'react';
import { HiLockClosed, HiLockOpen } from 'react-icons/hi';
import { RiGroupFill } from 'react-icons/ri';
import moment from 'moment';

export default function RoomListItem({ room, handleJoinRoom, handlePwJoinRoom, index }) {
  const { room_id, secret, subject, count, start_date, end_date } = room;
  const handleClick = () => {
    if (secret) {
      handlePwJoinRoom(room);
    } else {
      handleJoinRoom(room);
    }
  };
  return (
    <button
      key={room_id}
      className={` w-full max-w-[25rem] flex h-16 text-lg rounded-md mb-3 p-5 justify-between hover:bg-light hover:text-white cursor-pointer ${
        count >= 6 ? 'bg-gray-500' : 'bg-slate-200 '
      }`}
      onClick={handleClick}
      disabled={count >= 6}
    >
      <div className="flex items-center">
        <span className="mr-3 xs:text-xs sm:text-base">
          {secret ? <HiLockClosed /> : <HiLockOpen />}
        </span>
        <span className="xs:text-xs mr-3 sm:text-base">
          {subject.length > 5 ? subject.substr(0, 4) + '..' : subject}
        </span>
      </div>
      <div className="flex items-center">
        <span className="flex items-center xs:text-xs sm:text-base mr-1">
          <RiGroupFill className="mr-1" />
          {count} 명&nbsp;/&nbsp; {count >= 6 ? 'full' : ''}
        </span>
        <span className="xs:text-xs sm:text-base">
          {moment(start_date * 1000).format('MM.DD HH:mm')}
        </span>
        <span>&nbsp;~&nbsp;</span>
        <span className="xs:text-xs sm:text-base">
          {moment(end_date * 1000).format('MM.DD HH:mm')}
        </span>
      </div>
    </button>
  );
}
